import React from 'react'; 
import 'react-datepicker/dist/react-datepicker.css'; 
import Preloader from '../../../core/Preloader';
import { viewData } from '../../../core/HttpAction';
import { permissionCheck } from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import DetailView from '../../../core/DetailView';

const Url='/book'; 

class BookDetailView extends React.Component {
    constructor(props) {
        super(props); 
        this.state={ 
            data:[],
            preloader:this.props.match.params.id?true:false, 
        }; 
    }


    componentDidMount(){
 
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;


                    let result= [
                        {
                            label:'Title',
                            value:data.title?data.title:'',  
                        },
                        {
                            label:'ISBN No',
                            value:data.isbn_no?data.isbn_no:'',
                        },
                        {
                            label:'Access No',
                            value:data.access_number?data.access_number:'',  
                        }, 
                        {
                            label:'Rack No',
                            value:data.rack_no?data.rack_no:'',  
                        }, 
                        {
                            label:'DDCI No',
                            value:data.ddci_number?data.ddci_number:'',  
                        }, 
                        {
                            label:'Author Name',
                            value:data.author_name?data.author_name:'',  
                        }, 
                        {
                            label:'Publish Year',
                            value:data.publish_year?data.publish_year:'',  
                        }, 
                        {
                            label:'Quantity',
                            value:data.quantity?data.quantity:'',  
                        }, 
                        {
                            label:'Purchase Date',
                            value:data.purchase_date?data.purchase_date:'',  
                        }, 
                        {
                            label:'Entry Date',
                            value:data.entry_date?data.entry_date:'',  
                        }, 
                        {
                            label:'Edition',
                            value:data.edition?data.edition:'',  
                        }, 
                        {
                            label:'Price',
                            value:data.price?data.price:'',  
                        }, 
                        {
                            label:'Pages',
                            value:data.pages?data.pages:'',  
                        }, 
                        {
                            label:'Publisher',
                            value:data.publisher?data.publisher:'',  
                        }, 
                        {
                            label:'Due days for student',
                            value:data.no_of_due_days_student?data.no_of_due_days_student:'',  
                        }, 
                        {
                            label:'Due days for staff',
                            value:data.no_of_due_days_staff?data.no_of_due_days_staff:'',  
                        }, 
                        {
                            label:'Status',
                            value:data.status?'Active':'In-active',  
                        } 
                    ];


                    this.setState({data:result,preloader:false});
                   
                }
            });
        }
    } 
 
    render() {
        const {preloader,data} = this.state; 

        const role=permissionCheck('bookcategory','DetailView');
        const detailData={
            title:'Book', 
            data 
        };  

        if(!role)
            return <Nopermission/>;
        
        return (
            <div id="page_content_inner">
                <DetailView data={detailData} {...this.props}/>  
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default BookDetailView;


// WEBPACK FOOTER //
// ./src/components/Library/BookCategory/BookDetailView.js